module.exports = "https://static.moomoo.com/components/lottery2/images/bg.6cfd1cb224.png";